let setupFormFiltering = () => {
    document.querySelectorAll('.js-filter-group').forEach(group => {
        const checkboxes = group.querySelectorAll(
            'input[type="checkbox"]'
        ) as NodeListOf<HTMLInputElement>;

        const pillsContainer = group.querySelector<HTMLElement>('.js-selected-tags');
        if (!pillsContainer) {
            console.warn('Missing .js-selected-tags in filter group:', group);
            return;
        }

        const pills = pillsContainer.querySelector<HTMLElement>('.js-pills-container');
        const clearAllBtn = pillsContainer.querySelector<HTMLAnchorElement>('.js-clear-all');
        const toggleBtn = group.querySelector('.js-dropdown-btn');
        const menu = group.querySelector('.js-dropdown-menu');

        toggleBtn.addEventListener('click', () => {
            menu.classList.toggle('active');
            group.classList.toggle('open');
        });

        // Close dropdown when clicking outside
        document.addEventListener('click', (e: MouseEvent) => {
            const target = e.target as Element;
            // If the click was NOT inside the group (button or menu)
            if (!group.contains(target)) {
                menu.classList.remove('active');
                group.classList.remove('open');
            }
        });

        function updateSelected(): void {
            const selected = Array.from(checkboxes)
                .filter(cb => cb.checked)
                .map(cb => cb.value);

            pills.innerHTML = '';

            selected.forEach(value => {
                const pill = document.createElement('span');
                pill.className = 'filter-group__pill';

                // Add the user value safely as plain text
                const textNode = document.createTextNode(value);
                pill.appendChild(textNode);

                // Create the button
                const button = document.createElement('button');
                button.className = 'filter-group__pill-remove';
                button.type = 'button';
                button.setAttribute('aria-label', 'Click to Remove');

                // Add icon inside button
                const icon = document.createElement('i');
                icon.className = 'fa-solid fa-xmark-large';
                button.appendChild(icon);

                // Append button to pill
                pill.appendChild(button);

                // Add event listener to pill's close button
                pill.querySelector('button')?.addEventListener('click', () => {
                    const checkbox = Array.from(checkboxes).find(cb => cb.value === value);
                    if (checkbox) {
                        checkbox.checked = false;
                        updateSelected();
                    }
                });

                pills.appendChild(pill);
            });

            if (selected.length > 0) {
                pills.appendChild(clearAllBtn);
                pillsContainer.classList.remove('d-none');
            } else {
                pillsContainer.classList.add('d-none');
            }

            // Update count next to "Filter by Interest"
            const countEl = group.querySelector<HTMLElement>('.js-filter-count');
            if (countEl) {
                if (selected.length > 0) {
                    countEl.textContent = `(${selected.length})`;
                    countEl.classList.remove('d-none');
                } else {
                    countEl.classList.add('d-none');
                }
            }
        }

        // Listen for checkbox clicks
        checkboxes.forEach(cb => {
            cb.addEventListener('change', updateSelected);
        });

        // Handle clear all
        clearAllBtn.addEventListener('click', e => {
            e.preventDefault();
            checkboxes.forEach(cb => (cb.checked = false));
            updateSelected();
        });
    });
};

document.addEventListener('DOMContentLoaded', setupFormFiltering);